<div class="wallet-trx-status-container">
  <div class="wallet-trx-status-content">
    <p-messages class="paper-message" />
    <p-toast class="paper-toast"
        position="top-center"
        key="trx-status"
        (onClose)="clearStatusMessage()"
        [baseZIndex]="5000">
            <ng-template pTemplate>
              <div class="flex-1">
                <img [src]="'./assets/images/icon/messages/' + severity() + '.svg'" [alt]="severity() + 'icon'" />
                <span class="ml-2">{{ ('wallet_trx_status.message_' + displayStatus()) | translate }}</span>
              </div>
            </ng-template>
    </p-toast>
    <img
      [src]="'./assets/images/illust/il-trx-' + status + '.svg'"
      alt="transaction status"
      class="mt-48"
    />
    <ng-container>
      <h1 class="wallet-trx-status-title">
        {{ ('wallet_trx_status.title_' + displayStatus()) | translate }}
      </h1>
      <p class="wallet-trx-status-subtitle">
        {{ ('wallet_trx_status.desc_' + displayStatus()) | translate }}
      </p>
    </ng-container>
    <p-progress-spinner 
        *ngIf="status === 'PENDING'"
        fill="transparent" 
        animationDuration="1s"
        styleClass="spinner-blue" 
        [style]="{ width: '64px', height: '64px' }" />
    <div class="mt-100">
      <button 
        *ngIf="status === 'SUCCESS'" 
        type="button" 
        class="paper-button blue-button"
        (click)="viewTrxDetail()" 
        [class.disabled]="isLoading"
        [disabled]="isLoading"
      >
      {{ "wallet_trx_status.action_trx_detail" | translate }}
    </button>
    <div *ngIf="status === 'FAILED'">
      <button 
        type="button" 
        (click)="backToScanner()" 
        class="mt-20 paper-ghost-button blue-button">
        {{ "wallet_trx_status.action_back_scanner" | translate }}
      </button>
      <div class="mt-20">
        <a [href]="contactCSUrl" target="_blank" noopener noreferrer class="mt-20">
          <strong>{{ "wallet_trx_status.help" | translate }}</strong>
        </a>
      </div>
    </div>
    
    </div>
    
  </div>
</div>
    